"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.emailRegex = void 0;
exports.runValidation = runValidation;
exports.urlRegex = exports.urlHttpOptionalRegex = void 0;
exports.validateEmail = validateEmail;
exports.validateUrl = validateUrl;
exports.validateUrlHttpOptional = validateUrlHttpOptional;
exports.validationRules = void 0;
var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-float"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));
var _utils = require("./utils");
/* eslint-disable no-undef */

const validationRules = exports.validationRules = {
  email: {
    message: () => window.jQuery ? $.__('Please enter a valid email address.') : 'Please enter a valid email address.',
    predicate: validateEmail
  },
  max: {
    message: numberParam => window.jQuery ? $.__('Please enter a value less than or equal to %s.', numberParam) : `Please enter a value less than or equal to ${numberParam}.`,
    predicate: (value, numberParam) => value <= numberParam
  },
  maxLength: {
    message: lengthParam => window.jQuery ? $.__('Please enter no more than %s characters.', lengthParam) : `Please enter no more than ${lengthParam} characters.`,
    predicate: (value, lengthParam) => value?.length <= lengthParam
  },
  min: {
    message: numberParam => window.jQuery ? $.__('Please enter a value greater than or equal to %s.', numberParam) : `Please enter a value greater than or equal to ${numberParam}.`,
    predicate: (value, numberParam) => value >= numberParam
  },
  minLength: {
    message: lengthParam => window.jQuery ? $.__('Please enter at least %s characters.', lengthParam) : `Please enter at least ${lengthParam} characters.`,
    predicate: (value, lengthParam) => value?.length >= lengthParam
  },
  number: {
    message: () => window.jQuery ? $.__('Please enter a valid number.') : 'Please enter a valid number.',
    predicate: value => _utils.NUMBER_REGEX_PATTERN ? _utils.NUMBER_REGEX_PATTERN.test(value) : !isNaN((0, _parseFloat2.default)(value)) && isFinite(value)
  },
  required: {
    message: () => window.jQuery ? $.__('This field is required.') : 'This field is required.',
    predicate: value => {
      var _context;
      return Boolean(value) && Boolean((0, _trim.default)(_context = String(value)).call(_context));
    }
  },
  url: {
    message: () => window.jQuery ? $.__('Please enter a valid URL.') : 'Please enter a valid URL.',
    predicate: validateUrl
  },
  urlHttpOptional: {
    message: () => window.jQuery ? $.__('Please enter a valid URL.') : 'Please enter a valid URL.',
    predicate: validateUrlHttpOptional
  },
  valueSame: {
    message: () => window.jQuery ? $.__('These values must be the same.') : 'These values must be the same.',
    predicate: (value, otherValue) => String(value) === String(otherValue)
  },
  valueDifferent: {
    message: () => window.jQuery ? $.__('These values must be different.') : 'These values must be different.',
    predicate: (value, otherValue) => String(value) !== String(otherValue)
  }
};

/**
 * Runs validation on a given value, for the provided rules. If validation fails, returns an
 * object with the name of the failing rule and the specified message for ui display. Returns
 * empty object if no failing rules, including if not required and no value is supplied.
 * @param   {string}    value
 * @param   {object}    rules
 * @returns {{}|{rule: string, message: string}}
 */
function runValidation(value, rules = {}) {
  if (!rules.required && !validationRules.required.predicate(value)) {
    return {};
  }
  for (const ruleName in rules) {
    const ruleConfig = rules[ruleName];
    const param = Object.prototype.hasOwnProperty.call(ruleConfig, 'param') ? ruleConfig.param : ruleConfig; // param is value or nested value
    if (validationRules[ruleName] && !validationRules[ruleName].predicate(value, param)) {
      const message = Object.prototype.hasOwnProperty.call(ruleConfig, 'message') ? ruleConfig.message : validationRules[ruleName].message; // message fn is default or custom override included in rules object
      return {
        rule: ruleName,
        message: message(param)
      };
    }
  }
  return {};
}

/**
 * URL validation regular expression
 * Copyright (c) 2010-2018 Diego Perini (http://www.iport.it)
 * Source: https://gist.github.com/dperini/729294
 * Updated: 2018/09/12
 * License: MIT
 */
const urlRegex = exports.urlRegex = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
const urlHttpOptionalRegex = exports.urlHttpOptionalRegex = /^((https?|s?ftp):\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/i;

/**
 * @param    {string}    value
 * @returns  {boolean}
 */
function validateUrl(value) {
  return urlRegex.test(value);
}
function validateUrlHttpOptional(value) {
  return urlHttpOptionalRegex.test(value);
}
const emailRegex = exports.emailRegex = /^(?!\.)(?:[!#$%&'*\-+/=?^`{|~\w]|\.(?![.@])){1,64}@[a-z\d](?:[a-z\d]|-(?=[a-z\d-])|\.(?=[a-z\d])){0,250}\.[a-z]{2,}$/i;

/**
 * @param    {string}    value
 * @returns  {boolean}
 */
function validateEmail(value) {
  return emailRegex.test(value);
}